<template>
  <div id="map-container" class="map-container">
    <div id="parent"></div>
    <div class="controls">
      <button @click="setZoomFromBtn(0.05)">
        <img src="@/assets/plus_icon.svg" />
      </button>
      <button @click="setZoomFromBtn(-0.05)">
        <img src="@/assets/minus_icon.svg" />
      </button>
    </div>
  </div>
</template>
<script>
import * as d3 from "d3";
import { parseSvg } from "d3-interpolate/src/transform/parse";
import { inertiaHelper } from "d3-inertia";
import getTransformParametersSafari from "../functions/getTransformSafari";
import { gifs } from "@/variables/gifsConfig";
export default {
  name: "Map",
  data() {
    return {
      position: `translate(-3483.525146484375, -2950.2651)`,
      popupLayer: {},
      browserTypeSafari: false,
      zoom: 0.45,
      zoomer: {},
      map: {
        width: 0,
        height: 0,
      },
      mainParentConf: {
        width: 0,
        height: 0,
      },
      mapNode: null,
      gifs: gifs,
      browserTypeFf: false,
    };
  },
  props: {
    currentRoom: {
      type: [Number, undefined],
      default: null,
    },
  },
  watch: {
    currentRoom(newVal, oldVal) {
      oldVal !== null
        ? d3.select(`popup-${oldVal}`).style("background", "#F36C20")
        : "";
      this.setAnimationMap(newVal);
    },
  },
  methods: {
    setZoomFromBtn(counter) {
      this.zoom += counter;
      this.mapNode.call(
        //zoom used on nodegroup
        this.zoomer.scaleTo(this.mapNode.transition().duration(350), this.zoom)
      );
    },
    setActiveItemColor(i) {
      d3.select(`popup-${i}`).style("background", "#FF9600");
    },
    setDefaultItemColor(i) {
      d3.select(`popup-${i}`).style("background", "#F36C20");
    },
    popupClick(i) {
      this.setDefaultItemColor(this.$store.state.activeItemSidebar);
      this.setActiveItemColor(i);
      this.$store.commit("setSidebar", false);
      this.$store.commit("setSelectedItem", i);
      this.$store.commit("setSidebar", true);
    },
    getTransformParameters(transformString) {
      this.position = transformString;
      const values = parseSvg(transformString);
      let x = -1;
      let y = -1;
      if (this.browserTypeSafari) {
        const calc = getTransformParametersSafari(
          transformString,
          this.mainParentConf,
          this.map
        );
        x = calc.x;
        y = calc.y;
      } else {
        ///// horizontal
        if (values.translateX > 0) {
          //left
          x = -1;
        } else if (
          values.translateX <
          this.mainParentConf.width - this.map.width
        ) {
          //right
          x = this.mainParentConf.width - this.map.width;
        } else x = values.translateX;

        ////// vertical

        if (values.translateY > 0) {
          //top
          y = -1;
        } else if (
          //bottom
          values.translateY <
          this.mainParentConf.height - this.map.height
        ) {
          y = this.mainParentConf.height - this.map.height;
        } else y = values.translateY;
      }
      this.position = `translate(${x}, ${y})`;
      return { x, y };
    },
    zoomed({ transform }) {
      this.zoom = transform.k;
      this.groupNode.attr("transform", `scale(${this.zoom})`);
    },
    draw() {
      const values = parseSvg(this.position);
      this.position = `translate(${values.translateX}, ${values.translateY})`;
      this.mapNode.attr(
        "transform",
        `translate(${values.translateX}, ${values.translateY})`
      );
      this.popupLayer.attr(
        "transform",
        `translate(${values.translateX}, ${values.translateY})`
      );
    },
    setAnimationMap(i) {
      const item = this.$store.state.popups[i];
      this.setDefaultItemColor(this.$store.state.activeItemSidebar);
      this.setActiveItemColor(i);
      const easing = d3.easeSinInOut;
      this.groupNode
        .transition()
        .ease(easing)
        .delay(500)
        .duration(650)
        .call(this.zoomer.scaleTo, 0.4);
      this.mapNode
        .transition()
        .ease(easing)
        .duration(650)
        .delay(1150)
        .attr(
          "transform",
          `translate(${
            -item.acf.location_config.coords.x + this.mainParentConf.width / 2
          }, ${
            -item.acf.location_config.coords.y + this.mainParentConf.height / 2
          } )`
        );
      this.popupLayer
        .transition()
        .ease(easing)
        .duration(650)
        .delay(1150)
        .attr(
          "transform",
          `translate(${
            -item.acf.location_config.coords.x + this.mainParentConf.width / 2
          }, ${
            -item.acf.location_config.coords.y + this.mainParentConf.height / 2
          })`
        );
      this.groupNode
        .transition()
        .ease(easing)
        .duration(750)
        .delay(1200)
        .call(this.zoomer.scaleTo, 0.45);
      d3.zoomIdentity.k = 0.45;
    },
    addGifs() {
      // adding gifs
      this.gifs.forEach((gif) => {
        const popupBody = this.popupLayer
          .append("foreignObject")
          .attr(
            "style",
            `transform: translate(${gif.coords.x}px, ${gif.coords.y}px); pointer-events: none;`
          )
          .style("overflow", `visible`)
          .style("position", `fixed`)
          .attr("width", 1)
          .attr("height", 1)
          .append("xhtml:body")
          .attr("class", "popup-body")
          .append("xhtml:div")
          .style("position", `fixed`)
          .append("xhtml:img")
          .attr("src", require(`../assets/gifs/${gif.source}`))

          .attr("width", gif.width)
          .attr("height", gif.height);
        if (this.browserTypeFf) {
          popupBody.attr("style", `transform: scale(${this.zoom});`);
        }
      });

      //adaptive gif width
      //const windowWidth = window.innerWidth;
      // switch (windowWidth) {
      //   case windowWidth < 400:
      //     walkingPeopleGif.attr("src", "/gifs/WALKING-400px.gif");
      //     break;
      //   case windowWidth < 800:
      //     walkingPeopleGif.attr("src", "/gifs/WALKING-800.gif");
      //     break;
      //   case windowWidth < 1200:
      //     walkingPeopleGif.attr("src", "/gifs/WALKING-1200.gif");
      //     break;
      //   case windowWidth < 1600:
      //     walkingPeopleGif.attr("src", "/gifs/WALKING-1600.gif");
      //     break;
      //   case windowWidth < 1900:
      //     walkingPeopleGif.attr("src", "/gifs/WALKING-400px.gif");
      //     break;
      //   default:
      //     walkingPeopleGif.attr("src", "/gifs/WALKING-1200.gif");
      // }
    },
  },
  async mounted() {
    const self = this;
    this.mainParentConf = {
      width: window.innerWidth,
      // 100 - header height
      height: window.innerHeight - 100,
    };
    this.browserTypeFf =
      navigator.userAgent.includes("Safari") &&
      !navigator.userAgent.includes("Chrome");
    //initing svg
    const svg = d3
      .select("#parent")
      .append("svg")
      .attr("xmlns:xlink", "http://www.w3.org/1999/xlink")
      .attr("version", "1.1")
      .attr("xmlns", "http://www.w3.org/1999/svg")
      .attr("width", self.mainParentConf.width)
      .attr("height", self.mainParentConf.height);

    //appending map
    this.groupNode = svg.append("g").attr("transform", "scale(0.45)");

    this.zoomer = d3
      .zoom()
      .extent([
        [0, 0],
        [self.mainParentConf.width, self.mainParentConf.height],
      ])
      .scaleExtent([0.2, 2])
      .on("zoom", self.zoomed);

    this.mapNode = this.groupNode
      .attr("cursor", "grab")
      .append("svg:image")
      .attr("transform", "translate(-3483.525146484375, -2950.2651)")
      .attr("class", "image-node")
      .attr("xlink:href", "/tour/img/map.webp")
      .attr("id", "map-core");
    this.map = this.mapNode.node().getBBox();
    d3.select("#popup-layer").attr(
      "style",
      `height: ${self.map.height}px; width: ${self.map.width}px; pointer-events: none;`
    );

    //popups layer
    svg
      .append("style")
      .text(
        ".popup-body {position: fixed;} .popup { white-space: nowrap; position: absolute; background: #F36C20; border-radius: 50px;padding: 20px 100px 20px 20px; display: flex; align-items: center; justify-content: center; color: white;}  .popup p {font-size: 30px; font-weight: 500; letter-spacing: 0.835714px;} .info-btn {height: 45px; margin-right: 21px}"
      );
    this.popupLayer = this.groupNode
      .append("g")
      .attr("width", self.map.width)
      .attr("height", self.map.height);

    await this.addGifs();

    await this.$store.state.popups.forEach((item, i) => {
      const popupBody = this.popupLayer
        .append("foreignObject")
        .style(
          "transform",
          `translate(${item.acf.location_config.coords.x}px, ${item.acf.location_config.coords.y}px)`
        )
        .style("overflow", `visible`)
        .style("position", `fixed`)
        .attr("width", 1)
        .attr("height", 1)
        .append("xhtml:body")
        .attr("class", "popup-body")
        .append("xhtml:div")
        .style("position", `fixed`)
        .attr("id", `popup-${i}`)
        .on("click", () => self.popupClick(i))
        .attr("class", "popup")
        .html(
          `<img class="info-btn" src="/tour/img/info-icon.svg" />
            <p>${item.acf.location_config.title}</p>`
        );
      if (this.browserTypeFf) {
        popupBody.attr("style", `transform: scale(${this.zoom});`);
      }
    });

    this.draw();
    // eslint-disable-next-line no-unused-vars
    let offset = { x: 0, y: 0 };
    const inertia = inertiaHelper({
      start: function (e) {
        const transform = self.getTransformParameters(
          self.mapNode.attr("transform")
        );
        //
        self.map = self.mapNode.node().getBBox();
        offset = {
          x: transform.x - inertia.position[0] + e[0],
          y: transform.y - inertia.position[1] + e[1],
        };
      },
      move: function () {
        self.getTransformParameters(
          `translate(${inertia.position[0]}, ${inertia.position[1]})`
        );
        self.draw();
      },
      time: 1000,
      render: function (t) {
        const x = inertia.position[0] + 0.1 * t * inertia.velocity[0];
        const y = inertia.position[1] + 0.1 * t * inertia.velocity[1];
        self.getTransformParameters(`translate(${x}, ${y})`);
        self.draw();
      },
    });
    // do not mix this calls on same elem!
    this.groupNode.call(
      // drag is used on map img only
      d3
        .drag()
        .on("start", inertia.start)
        .on("drag", function (e) {
          /* getTransformParameters should return current element position */
          const params = self.getTransformParameters(
            self.mapNode.attr("transform")
          );
          inertia.move({
            x: params.x + e.dx,
            y: params.y + e.dy,
          });
        })
        .on("end", inertia.end)
    );

    this.groupNode.call(
      //zoom used on nodegroup
      self.zoomer
    );
    d3.zoomIdentity.k = 0.45;
    if (this.currentRoom) {
      this.setAnimationMap(this.currentRoom);
    }
  },
};
</script>
<style scoped lang="scss">
@import "../assets/styles/_colors";
@import "../assets/styles/_variables";
.map-container {
  position: absolute;
  width: 100%;
  touch-action: none;
  user-select: none;
  height: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
}
#parent {
  &::v-deep {
    .image-node {
      width: 6971px;
    }
  }
}
.controls {
  position: fixed;
  z-index: 1000;
  bottom: 50px;
  left: 25px;
  background: black;
  display: flex;
  flex-direction: column;
  button {
    cursor: pointer;
    width: 45px;
    height: 45px;
    border: none;
    &:hover {
      background: $orange;
    }
    img {
      width: 100%;
    }
  }
}
#map {
  touch-action: none;
  position: absolute;
  user-select: none;
  background: black;
}
.map {
  pointer-events: none;
  touch-action: none;
  user-select: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
.popup-layer {
  position: absolute;
}
.popup {
  position: absolute;
  background: $orange;
  border-radius: 25px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  img {
    object-fit: cover;
    width: 30px;
    height: 30px;
  }
  p {
    font-size: 20px;
  }
  &:hover {
    background: black;
  }
}
#parent {
  width: 100%;
  height: 100%;
}

.circle {
  fill: blue;
}
</style>
